import {
  colors,
  ImpButton,
  ImpButtonProps,
  ImpCard,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';

import {
  FORM_BUTTON_WIDTH,
  webServicingDisplayURL,
  webServicingURL,
} from '../../assets/consts/const';
import {
  emitSDKEvent,
  emitSDKResult,
  isWebIframe,
  SDK_EVENTS,
  useSDKContext,
} from '../../utils/sdk';
import OnboardingLayout from './OnboardingLayout';

export interface OfferNotAcceptedPageProps {
  cardImg: string;
  title: string;
  subtitle: string;
  merchantName: string;
  onBackToOffer: () => void;
}

export default function OfferNotAcceptedPage({
  cardImg,
  title,
  subtitle,
  merchantName,
  onBackToOffer,
}: OfferNotAcceptedPageProps) {
  const { result } = useSDKContext();

  const handleBackToPartner = () => {
    emitSDKResult({
      result,
    });
    emitSDKEvent({
      event: SDK_EVENTS.CLOSED,
    });
  };

  //TODO: the button texts could be fetched from BE as well.
  const buttonProps: ImpButtonProps[] = [
    {
      children: `Back to ${merchantName}`,
      variant: 'primary',
      buttonStyle: 'branded',
      onClick: handleBackToPartner,
    },
    {
      children: 'Back to my offer',
      variant: 'tertiary',
      buttonStyle: 'branded',
      onClick: onBackToOffer,
    },
  ];

  const getSubtitle = () => {
    if (!subtitle.includes(webServicingDisplayURL)) return subtitle;

    const parts = subtitle.split(webServicingDisplayURL);
    return (
      <>
        {parts[0]}
        <ImpButton
          variant="inline"
          buttonStyle="branded"
          onClick={() => {
            if (isWebIframe()) {
              window.open(webServicingURL, '_blank');
            } else {
              window.location.href = webServicingURL;
            }
          }}
        >
          {webServicingDisplayURL}
        </ImpButton>
        {parts[1] || ''}
      </>
    );
  };

  return (
    <OnboardingLayout bottomButtons={buttonProps}>
      <ImpSpacer height="l" />
      <ImpCard src={cardImg} width={FORM_BUTTON_WIDTH} />
      <ImpSpacer height="xl" />
      <ImpText typography="headline3">{title}</ImpText>
      <ImpSpacer height="xs" />
      <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
        {getSubtitle()}
      </ImpText>
    </OnboardingLayout>
  );
}
